<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()
useSeoMeta({ title: props.error.statusCode })

let message = 'Unknown Error'
if (props.error.statusCode === 404) {
  message = 'Page Not Found'
} else if (props.error.statusMessage) {
  message = props.error.statusMessage
}
</script>

<template>
  <NuxtLayout>
    <div class="grow self-center flex flex-col justify-center gap-2">
      <h1>{{ error.statusCode }}</h1>
      <div>{{ message }}</div>
      <UButton to="/">Back to Home</UButton>
    </div>
  </NuxtLayout>
</template>
